/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequest interface.
 */
export function instanceOfFxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequest(value) {
    if (!('Key' in value) || value['Key'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequestFromJSON(json) {
    return FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Key': json['Key'],
    };
}
export function FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequestToJSON(json) {
    return FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Key': value['Key'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesFtlIntegrationLauncherActivateKeyRequest.js.map